import { useState, useEffect } from "react";
import { ImageValidation } from "../Validation/ImageValidation";
import { toast } from "react-toastify";
import config from "../../utils/config";
import { useKycBankVerifyMutation } from "../../redux/kycApi";
import Rejectreason from "./Rejectreason";

const { imageUrl } = config;

const Bank = ({ kycTrack, refetch }) => {
  const [image, setImage] = useState("/assets/img/icon2.png");
  const [acType, setAcType] = useState("");
  const [bankImage, setBankImage] = useState(null);
  const [useruploadBankImage, setUseruploadBankImage] = useState("");
  const [acTypeError, setAcTypeError] = useState("");
  const [bankImageError, setBankImageError] = useState("");
  const [accHolderName, setAccHolderName] = useState("");
  const [accHolderNameError, setAccHolderNameError] = useState("");
  const [accNumber, setAccNumber] = useState("");
  const [accNumberError, setAccNumberError] = useState("");
  const [ifsc, setIfsc] = useState("");
  const [ifscCodeError, setIfscCodeError] = useState("");
  const [swift, setSwift] = useState("");
  const [swiftCodeError, setSwiftCodeError] = useState(""); // Correctly initialized state
  const [countryCode, setCountryCode] = useState("");
  const [btnDisable, setBtnDisable] = useState(false);

  const [kycBankVerify] = useKycBankVerifyMutation();

  useEffect(() => {
    const bankData = kycTrack?.progress?.bank_verification?.data;
    const country_code = kycTrack?.country_code;

    const loadImageAsFile = async (url, filename = "bank_proof.jpg") => {
      try {
        const res = await fetch(url);
        const blob = await res.blob();
        return new File([blob], filename, { type: blob.type });
      } catch (err) {
        console.error("Failed to convert image URL to File:", err);
        return null;
      }
    };

    if (bankData) {
      setAccHolderName(bankData.account_holder_name || "");
      setAccNumber(bankData.account_number || "");
      if (country_code === "+91") {
        setIfsc(bankData.ifsc_code || "");
      } else {
        setSwift(bankData.ifsc_code || "");
      }
      setAcType(bankData.account_type || "");

      const imgPath = imageUrl + "/" + bankData.proof_photo;
      setImage(imgPath);
      setUseruploadBankImage(imgPath);

      loadImageAsFile(imgPath, bankData.proof_photo).then((file) => {
        if (file) setBankImage(file);
      });
    }

    setCountryCode(kycTrack?.country_code || "");
  }, [kycTrack]);

  const handleChange = (e) => {
    let { name, value, files } = e.target;

  

    switch (name) {
      case "acType":
        setAcType(value);
        setAcTypeError(value ? "" : "This field is required");
        break;

case "accHolderName":
  setAccHolderName(value);

  if (!value) {
    setAccHolderNameError("This field is required");
  }

  // 🔹 Leading space
  else if (/^\s/.test(value)) {
    setAccHolderNameError("Name cannot start with a space");
  }

  // 🔹 Trailing space
  else if (/\s$/.test(value)) {
    setAccHolderNameError("Name cannot end with a space");
  }

  else if (value.length < 2 || value.length > 35) {
    setAccHolderNameError("Name must be 2 to 35 characters long");
  }

  else if (!/^[A-Za-z ]+$/.test(value)) {
    setAccHolderNameError("Name can only contain alphabets and spaces");
  }
// 
  else {
    setAccHolderNameError("");
  }
  break;

      case "accNumber":
        // Block non-numeric input
        if (!/^\d*$/.test(value)) {
          return; // 🚫 do nothing if it's not number
        }

        setAccNumber(value);

        const isSequentialAsc = "1234567890".includes(value);
        const isSequentialDesc = "0987654321".includes(value);

        if (!value) {
          setAccNumberError("This field is required");
        } else if (!/^[0-9]{7,18}$/.test(value)) {
          setAccNumberError("Account number must be 7–18 digits");
        } else if (/^(\d)\1+$/.test(value)) {
          setAccNumberError("Account number cannot be all same digits");
        } else if (isSequentialAsc || isSequentialDesc) {
          setAccNumberError("Sequential account numbers are not allowed");
        } else {
          setAccNumberError("");
        }
        break;

      case "ifsc":
        if (value) {
          setIfsc(value.toUpperCase());
        } else {
          setIfsc(value);
        }
        if (!value) {
          setIfscCodeError("This field is required");
        } else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(value)) {
          // ✅ Ensures exactly 4 letters + 0 + 6 alphanumeric
          setIfscCodeError(
            "Please enter a valid IFSC code (e.g., HDFC0AB1234)"
          );
        } else {
          setIfscCodeError("");
        }
        break;

      case "swift":
        const swiftVal = value ? value.toUpperCase() : value;
        setSwift(swiftVal);

        // Required field
        if (!swiftVal) {
          setSwiftCodeError("SWIFT Code is required.");
          break;
        }

        // Only allowed characters
        if (!/^[A-Z0-9]+$/.test(swiftVal)) {
          setSwiftCodeError(
            "SWIFT Code must contain only uppercase letters and numbers."
          );
          break;
        }

        // Minimum and maximum length check
        if (swiftVal.length < 8) {
          setSwiftCodeError("SWIFT Code must be at least 8 characters.");
          break;
        } else if (swiftVal.length > 11) {
          setSwiftCodeError("SWIFT Code cannot be longer than 11 characters.");
          break;
        }

        // Format validation
        if (
          !/^([A-Z]{4})([A-Z]{2})([A-Z0-9]{2})([A-Z0-9]{3})?$/.test(swiftVal)
        ) {
          setSwiftCodeError("Enter a valid SWIFT Code (e.g., ABCDUS33XXX).");
          break;
        }

        // If all checks pass, clear error
        setSwiftCodeError("");
        break;

      case "bankImage":
        const file = files[0];
        if (file) {
          const error = ImageValidation("Bank image", file);
          setBankImageError(error);
          setBankImage(file);
          setUseruploadBankImage(URL.createObjectURL(file));
        } else {
          setBankImageError("This field is required");
          setBankImage(null);
          setUseruploadBankImage("");
        }
        break;

      default:
        break;
    }
  };

  const handleValidation = (e) => {
    if (/[eE\-+!@#$%^&*()]/.test(e.key)) e.preventDefault();
  };

  const handleSubmit = async () => {
    setBtnDisable(true);
    setTimeout(() => setBtnDisable(false), 3000); // Prevent rapid clicks

    const isIFSCValid = countryCode === "+91" ? !!ifsc && !ifscCodeError : true;
    const isSWIFTValid =
      countryCode !== "+91" ? !!swift && !swiftCodeError : true;

    // Set errors for empty fields (in case user never touched them)
    if (!acType && !acTypeError) setAcTypeError("This field is required");
    if (!accHolderName && !accHolderNameError)
      setAccHolderNameError("This field is required");
    if (!accNumber && !accNumberError)
      setAccNumberError("This field is required");
    if (countryCode === "+91" && !ifsc && !ifscCodeError)
      setIfscCodeError("IFSC code is required");
    if (countryCode !== "+91" && !swift && !swiftCodeError)
      setSwiftCodeError("SWIFT code is required");
    if (!bankImage && !bankImageError)
      setBankImageError("This field is required");

    // 🔒 Stop immediately if any error state still exists
    if (
      !acType ||
      !accHolderName ||
      !accNumber ||
      !bankImage ||
      !isIFSCValid ||
      !isSWIFTValid ||
      acTypeError ||
      accHolderNameError ||
      accNumberError ||
      ifscCodeError ||
      swiftCodeError ||
      bankImageError
    ) {
      // toast.error("Please fix the errors before submitting");
      return; // 🛑 Exit here
    }

    setBtnDisable(true);

    const formData = new FormData();
    formData.append("file", bankImage);
    formData.append("account_type", acType);
    formData.append("account_number", accNumber);
    formData.append("account_holder_name", accHolderName);
    if (ifsc) formData.append("ifsc_code", ifsc);
    if (swift) formData.append("ifsc_code", swift);

    try {
      const { data, error } = await kycBankVerify(formData);
      if (error) {
        toast.error(error?.data?.message || "Something went wrong");
      } else if (data?.status) {
        toast.success(data.message || "Submitted successfully");
        refetch();
      } else {
        toast.error(data?.message || "Failed to submit");
      }
    } catch (err) {
      toast.error("An unexpected error occurred.");
    } finally {
      setBtnDisable(false);
    }
  };

  const status = kycTrack?.progress?.bank_verification?.status;
  const isEditable = status === "pending" || status === "rejected";

  return (
    <>
      <div className="bank-outer">
        <div className="">
          {/* <div className="col-md-3 col-12"></div> */}
          <div className="">
            <div className="white_box">
              <h6 className="position-relative">
                Bank Verification
              </h6>
              <b className="mt-0">Requirements</b>
              <ul className="dit_ul mb-4">
                <li>
                  The document must be valid at least 3 months after the
                  verification submission date.
                </li>
              </ul>
              <div className="row">
                <div className="col-md-8">
                  <div className="row">
                    <div className="form-group  col-md-6">
                      <label>Account Type</label>
                      <select
                        className="form-control"
                        name="acType"
                        value={acType}
                        onChange={handleChange}
                        disabled={!isEditable}
                      >
                        <option value={""}>Select</option>
                        <option value={"savings"}>Savings Account</option>
                        <option value={"current"}>Current Account</option>
                      </select>
                      {acTypeError && (
                        <div className="text-danger">{acTypeError}</div>
                      )}
                    </div>

                    <div className="form-group  col-md-6">
                      <label>Account Holder Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Account Holder Name"
                        name="accHolderName"
                        value={accHolderName}
                        maxLength={40}
                        onChange={handleChange}
                        disabled={!isEditable}
                      />
                      {accHolderNameError && (
                        <div className="text-danger">{accHolderNameError}</div>
                      )}
                    </div>
                    <div className="form-group  col-md-6">
                      <label>Account Number </label>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter Account Number"
                        name="accNumber"
                        value={accNumber}
                        onKeyPress={handleValidation}
                        onChange={handleChange}
                        disabled={!isEditable}
                      />
                      {accNumberError && (
                        <div className="text-danger">{accNumberError}</div>
                      )}
                    </div>

                    {countryCode === "+91" && (
                      <div className="form-group  col-md-6">
                        <label>IFSC Code</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter IFSC Code(AAAA0BBBBBB)"
                          name="ifsc"
                          value={ifsc}
                          onChange={handleChange}
                          disabled={!isEditable}
                        />
                        {ifscCodeError && (
                          <div className="text-danger">{ifscCodeError}</div>
                        )}
                      </div>
                    )}

                    {countryCode !== "+91" && (
                      <div className="form-group  col-md-6">
                        <label> SWIFT Code </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter SWIFT Code"
                          name="swift"
                          value={swift}
                          onChange={handleChange}
                          disabled={!isEditable}
                        />
                        {swiftCodeError && (
                          <div className="text-danger">{swiftCodeError}</div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div className="form-group col-md-4">
                  <label>PassBook / Cheque Book / Bank Statement</label>
                  <div id="file-upload-form" className="uploader">
                    <input
                      type="file"
                      id="file-upload2"
                      name="bankImage"
                      accept=".png, .jpg, .jpeg"
                      onChange={handleChange}
                      disabled={!isEditable}
                    />
                    <label htmlFor="file-upload2" id="file-drag">
                      <img
                        src={
                          useruploadBankImage !== ""
                            ? useruploadBankImage
                            : image
                        }
                        className="img-fluid22"
                        alt="BankImage"
                      />
                      <div id="start">
                        <span className="fasi"></span>
                        <div>Bank Image</div>
                      </div>
                      <div id="response" className="hidden">
                        <div id="messages"></div>
                        <progress
                          className="progress"
                          id="file-progress"
                          value="0"
                        >
                          <span>0</span>%
                        </progress>
                      </div>
                    </label>
                  </div>
                  <p className="mt-0">
                    *Only jpeg, jpg &amp; png files supported. *For changing
                    image, click on image upload section again.
                  </p>
                  {bankImageError && (
                    <div className="text-danger">{bankImageError}</div>
                  )}
                </div>
              </div>
              <Rejectreason
                status={kycTrack?.progress?.bank_verification?.status}
                reason={kycTrack?.progress?.bank_verification?.data?.reason}
              />
              {isEditable && (
                <button
                  className="btn btn_man w100px"
                  onClick={handleSubmit}
                  disabled={btnDisable}
                >
                  {status === "rejected" ? "Re-submit" : "Submit"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Bank;
